import axiosV1 from "@/plugins/axios/configV1";

export default {
    getFunctions() {
        return axiosV1.get("activity-logs/functions");
    },
    getActivityLogs(params = {}, config = {}) {
        return axiosV1.get("activity-logs", { params, ...config });
    },

    exportExcel(params = {}) {
        return axiosV1.get(`activity-logs/export`, { params });
    },
};
